var checkIdCardNo = function (code) {
    var city = { 11: "北京", 12: "天津", 13: "河北", 14: "山西", 15: "内蒙古", 21: "辽宁", 22: "吉林", 23: "黑龙江 ", 31: "上海", 32: "江苏", 33: "浙江", 34: "安徽", 35: "福建", 36: "江西", 37: "山东", 41: "河南", 42: "湖北 ", 43: "湖南", 44: "广东", 45: "广西", 46: "海南", 50: "重庆", 51: "四川", 52: "贵州", 53: "云南", 54: "西藏 ", 61: "陕西", 62: "甘肃", 63: "青海", 64: "宁夏", 65: "新疆", 71: "台湾", 81: "香港", 82: "澳门", 91: "国外 " };
    var tip = "";
    var pass = true;

    if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
        tip = "身份证号格式错误";
        pass = false;
    }

    else if (!city[code.substr(0, 2)]) {
        tip = "地址编码错误";
        pass = false;
    }
    else {
        //18位身份证需要验证最后一位校验位
        if (code.length == 18) {
            code = code.split('');
            //∑(ai×Wi)(mod 11)
            //加权因子
            var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            //校验位
            var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            var sum = 0;
            var ai = 0;
            var wi = 0;
            for (var i = 0; i < 17; i++) {
                ai = code[i];
                wi = factor[i];
                sum += ai * wi;
            }
            var last = parity[sum % 11];
            if (parity[sum % 11] != code[17]) {
                tip = "校验位错误";
                pass = false;
            }
        }
    }
    return pass;
}

var getBirthday = function (idNo) {
    let birthdayNo = idNo.substring(6, 14);
    let birthday = birthdayNo.substring(0, 4) + "-" + birthdayNo.substring(4, 6) + "-" + birthdayNo.substring(6, 8)
    return birthday;
}

var autoDiscern = function (str) {
    //省份
    var province = ["广东", "北京", "浙江", "福建", "湖北", "上海", "江苏", "天津", "河北", "山西", "内蒙古", "辽宁", "吉林", "黑龙江", "安徽", "江西", "山东", "河南", "湖南", "广西", "海南", "重庆", "四川", "贵州", "云南", "西藏", "陕西", "甘肃", "青海", "宁夏", "新疆", "台湾", "香港", "澳门"];

    var other = [];
    var nameAndaddress = '';
    var name = '';
    var provName = '';
    var address = '';

    /**
     * 要求客户按照逗号或者空格区分开电话、姓名和地址
     * 为了方便处理，先把所有的逗号和空格统一用,分割
     * 至少地址和姓名必须严格要求分开，因为手机号码可以正常匹配不管怎么写
     */
    str = str.replace(/^(\s*)|(\s*)$/g, '').replace(/\s+/g, ' ');// 去掉左右两边的空格，并把中间多个空格替换成一个空格，这样就可以把空格转逗号
    str = str.replace(new RegExp(" ,", "g"), ',').replace(new RegExp(", ", "g"), ',').replace(new RegExp(" ，", "g"), ',').replace(new RegExp("， ", "g"), ',');//空格逗号 逗号空格都转逗号
    str = str.replace(new RegExp(" ", "g"), ',').replace(new RegExp("，", "g"), ',');
    if (str.split(',').length > 3) {// 如果规范后,大于3个，那么表示这是一个格式错误的地址，无法解析
        return {
            success: false,
            message: '地址格式不对'
        }
    } else {
        var phone = str.match(/((13[0-9])|(15[^4])|(18[0,1,2,3,5-9])|(17[0-8])|(147))\d{8}/g);
        if (phone) {
            phone = phone.toString().replace(new RegExp(",", "g"), '').replace(new RegExp(" ", "g"), '');
            //去掉手机号剩下的
            nameAndaddress = str.replace(phone+',', '').replace(','+phone, '');
            let nameAndaddressArray = nameAndaddress.split(",");

            if (nameAndaddressArray.length != 2) {
                return {
                    success: false,
                    message: '地址格式不对'
                }
            } else {
                let haveProv = false;
                nameAndaddressArray[0] = nameAndaddressArray[0].replace(new RegExp(" ", "g"), '');
                nameAndaddressArray[1] = nameAndaddressArray[1].replace(new RegExp(" ", "g"), '');
                for (let i = 0; i < province.length; i++) {
                    if (nameAndaddressArray[0].indexOf(province[i]) == 0) {//数组中第一个是省份
                        haveProv = true;
                        provName = province[i];
                        address = nameAndaddressArray[0];
                        name = nameAndaddressArray[1];
                        break;
                    } else if (nameAndaddressArray[1].indexOf(province[i]) == 0) {//没有省份信息
                        haveProv = true;
                        provName = province[i];
                        address = nameAndaddressArray[1];
                        name = nameAndaddressArray[0];
                        break;
                    }
                }

                if (haveProv) {
                    return {
                        success: true,
                        data: {
                            name: name,
                            phone: phone,
                            address: address,
                            provName: provName
                        }
                    }
                } else {
                    return {
                        success: false,
                        message: '地址格式不对'
                    }
                }
            }
        } else {
            return {
                success: false,
                message: '地址有误请重新填入'
            }
        }
    }
}

module.exports = {
    checkIdCardNo: checkIdCardNo,
    getBirthday: getBirthday,
    autoDiscern: autoDiscern
};


// WEBPACK FOOTER //
// ./src/utils/commonUtil.js